import { inject, Injectable } from '@angular/core';
import { BizzMineLocalStorageService } from 'src/app/shared/services/localStorage/bizzmine-local-storage.service';
import { BizzMineSessionStorageService } from 'src/app/shared/services/localStorage/bizzmine-session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkStorageService {
  public localStorage = inject(BizzMineLocalStorageService);
  public sessionStorage = inject(BizzMineSessionStorageService);
  
  public getStorage(isPwa: boolean): Storage {
    return isPwa ? this.localStorage : this.sessionStorage;
  }

  public getAccessToken(isPwa: boolean): Promise<string> {
    const readToken = (): string | null => this.getStorage(isPwa).getItem('access_token');

    return new Promise((resolve) => {
      let value = readToken();
      if (value != null && value.trim() !== '') {
        resolve(value);
      } else {
        const interval = setInterval(() => {
          value = readToken();
          if (value != null && value.trim() !== '') {
            clearInterval(interval);
            resolve(value);
          }
        }, 1000);
      }
    });
  }
}
